import {ErrorMessage, Form, Formik} from 'formik'
import {isEmpty} from 'lodash'
import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import {Modal} from 'rsuite'
import {GalleryModel} from 'src/app/modules/cms/components/gallery/Model'
import * as galleryRedux from 'src/app/modules/cms/components/gallery/redux'
import {FormOptionModal} from 'src/app/modules/cms/components/menu/Model'
import {StateParamsModel} from 'src/app/modules/common/Model'
import checkBackendSetting from 'src/app/modules/common/checkBackendSetting'
import FormInputMediaManager from 'src/cms/helpers/components/forms/FormInputMediaManager'
import FormRadio from 'src/cms/helpers/components/forms/FormRadio'
import FormSelect from 'src/cms/helpers/components/forms/FormSelect'
import FormTextBox from 'src/cms/helpers/components/forms/FormTextBox'
import FormTinyMce from 'src/cms/helpers/components/forms/FormTinyMce'
import {imageBaseUrl} from 'src/cms/helpers/constants'
import * as Yup from 'yup'
import * as csrCategory from '../../category'
import {ICsrCategoryState} from '../../category/redux/reducer'
import {CsrOptionModel} from '../Model'
import * as csr from '../index'
import * as csrRedux from '../index'

type Props = {
  open: boolean
  params?: StateParamsModel
  handleClose: () => void
  actionType: string
  editSelectedData?: any
}

const FORM_VALIDATION = Yup.object().shape({
  title: Yup.string().required('Title is required'),
  status: Yup.string().required('Status is required'),
  shortDescription: Yup.string().max(250, 'Short Description exceeds 250 characters').nullable(),
  shortDescriptionNp: Yup.string()
    .max(250, 'Short Description Nepali exceeds 250 characters')
    .nullable(),
})

const AddCsr = ({open, params, handleClose, actionType, editSelectedData}: Props) => {
  const dispatch = useDispatch()
  const {csrFileType, loading, success} = useSelector((state: any) => state.csr)
  const {
    data: {album},
  } = useSelector((state: any) => state.gallery)

  const [thumbImageUrl, setThumbImageUrl] = useState<any>('')
  const [fileUrl, setFileUrl] = useState<any>('')

  const csrCategoryData: ICsrCategoryState = useSelector((state: any) => state.csrCategory)

  const statusOptions = [
    {label: 'Active', value: 'Active'},
    {label: 'Inactive', value: 'Inactive'},
  ]

  const albumOptions = album?.map((items: GalleryModel) => ({
    label: items.title,
    value: items.id,
  }))

  const categoryOptions = csrCategoryData?.data?.csrCategory?.map((items: any) => ({
    label: items.title,
    value: items.id,
  }))

  const fileOptions = csrFileType?.map((items: CsrOptionModel) => ({
    label: items.displayName,
    value: items.id,
    systemName: items.systemName,
  }))

  useEffect(() => {
    dispatch(csrRedux.actions.getCsrFileType())
    dispatch(galleryRedux.actions.getAllGallery())
  }, [])

  useEffect(() => {
    if (success) {
      isEmpty(editSelectedData)
        ? toast.success('CSR added successfully')
        : toast.success('CSR edited successfully')
      dispatch(csr?.actions?.addCsrItemReset())
      dispatch(csr?.actions.getCsrData(params))
      handleClose()
    }
  }, [success])

  const initialValues = {
    title: '',
    titleNp: '',
    slug: '',
    shortDescription: '',
    shortDescriptionNp: '',
    description: '',
    descriptionNp: '',
    status: '',
    thumbnailImage: '',
    fileType: '',
    file: '',
    albumId: '',
    csrCategoryId: '',
    published_date: '',
  }

  const convertToSlug = (text: string) => {
    return text
      .toLowerCase()
      .replace(/ /g, '-')
      .replace(/[^\w-]+/g, '')
  }

  const isCsrCategoryNeeded = checkBackendSetting('isCsrCategoryNeeded')

  if (isCsrCategoryNeeded === true) {
    useEffect(() => {
      dispatch(csrCategory.actions.getCsrCategoryDropdown())
    }, [])
  }

  return (
    <div className='modal-container' data-cy='add-modal-csr-container'>
      <Modal
        open={open}
        onClose={handleClose}
        size='lg'
        backdrop='static'
        keyboard={false}
        enforceFocus={false}
        data-cy='modal'
      >
        <Modal.Header>
          <Modal.Title data-cy='modal-title'>{actionType} CSR</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Formik
              initialValues={initialValues}
              validationSchema={FORM_VALIDATION}
              onSubmit={(values: any) => {
                const formData = {
                  ...values,
                  slug: !isEmpty(editSelectedData)
                    ? editSelectedData?.slug
                    : values?.title.replace(/\s/g, '-').toLowerCase(),
                  status: values?.status === 'Active' ? true : false,
                }

                if (!isEmpty(editSelectedData)) {
                  dispatch(csr.actions.updateCsrItem(formData, editSelectedData?.id))
                } else {
                  dispatch(csr.actions.addCsrItem(formData))
                }
              }}
            >
              {({isSubmitting, touched, handleChange, errors, setFieldValue, values}) => {
                useEffect(() => {
                  if (!isEmpty(editSelectedData)) {
                    const fields = [
                      'title',
                      'titleNp',
                      'shortDescription',
                      'shortDescriptionNp',
                      'description',
                      'descriptionNp',
                      'published_date',
                      'slug',
                      'status',
                      'thumbnailImage',
                      'file',
                      'fileType',
                      'albumId',
                      'csrCategoryId',
                    ]
                    fields.forEach((field) => setFieldValue(field, editSelectedData[field], false))
                    setFieldValue(
                      'status',
                      editSelectedData?.status === true ? 'Active' : 'Inactive',
                      false
                    )
                  }
                }, [])

                const chosenFileType = fileOptions.find(
                  (item: FormOptionModal) => item.value === values.fileType
                )
                return (
                  <Form>
                    <div className='card-body border-top pt-5' data-cy='add-csr-body'>
                      <div className='row'>
                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            type='text'
                            placeholder='Enter Title'
                            name='title'
                            label='Title (EN)'
                            containerClassName=''
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            required={true}
                            data-cy='add-csr-title-text-field'
                          />
                        </div>
                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            type='text'
                            placeholder='Enter Title (NP)'
                            name='titleNp'
                            label='Title (NP)'
                            containerClassName=''
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            data-cy='add-csr-title-np-text-field'
                          />
                        </div>

                        <div className='col-md-6 col-xs-12'>
                          <FormTinyMce
                            containerClassName='col-md-12'
                            label='Description (EN)'
                            name='description'
                            initialValue={
                              !isEmpty(editSelectedData) ? editSelectedData?.description : ''
                            }
                            handleChange={handleChange}
                            data-cy='add-csr-description-textarea'
                          />
                        </div>
                        <div className='col-md-6 col-xs-12'>
                          <FormTinyMce
                            containerClassName='col-md-12'
                            label='Description (NP)'
                            name='descriptionNp'
                            initialValue={
                              !isEmpty(editSelectedData) ? editSelectedData?.descriptionNp : ''
                            }
                            handleChange={handleChange}
                            data-cy='add-csr-description-np-textarea'
                          />
                        </div>

                        <div className='col-md-6 col-xs-12'>
                          <FormTinyMce
                            containerClassName='col-md-12'
                            label='Short Description (EN)'
                            name='shortDescription'
                            initialValue={
                              !isEmpty(editSelectedData) ? editSelectedData?.shortDescription : ''
                            }
                            handleChange={handleChange}
                            data-cy='add-csr-short-description-textarea'
                          />
                        </div>
                        <div className='col-md-6 col-xs-12'>
                          <FormTinyMce
                            containerClassName='col-md-12'
                            label='Short Description (NP)'
                            name='shortDescriptionNp'
                            initialValue={
                              !isEmpty(editSelectedData) ? editSelectedData?.shortDescriptionNp : ''
                            }
                            handleChange={handleChange}
                            data-cy='add-csr-short-description-np-textarea'
                          />
                        </div>

                        <div className='row justify-content-between mt-5'>
                          <div className='col-md-6 col-xs-12'>
                            <FormTextBox
                              type='text'
                              labelClassName='col-md-12'
                              containerClassName='col-md-12'
                              placeholder='Enter slug'
                              label='Slug'
                              name='slug'
                              onChange={handleChange}
                              errors={errors}
                              touched={touched}
                              disabled={true}
                              value={
                                !isEmpty(editSelectedData)
                                  ? editSelectedData?.slug
                                  : convertToSlug(values?.title)
                              }
                              data-cy='add-csr-slug-text-field'
                            />
                          </div>

                          {isCsrCategoryNeeded && (
                            <div className='col-md-6 col-xs-12'>
                              <FormSelect
                                type='text'
                                labelClassName='col-md-12'
                                containerClassName='col-md-12'
                                placeholder='Please select category'
                                label='Category'
                                name='csrCategoryId'
                                onChange={handleChange}
                                errors={errors}
                                touched={touched}
                                options={categoryOptions}
                                values={values}
                                setFieldValue={setFieldValue}
                                data-cy='add-csr-category-select-field'
                              />
                            </div>
                          )}

                          <div className='col-md-6 col-xs-12'>
                            <FormSelect
                              type='text'
                              labelClassName='col-md-12'
                              containerClassName='col-md-12'
                              placeholder='Please select album'
                              label='Album'
                              name='albumId'
                              onChange={handleChange}
                              errors={errors}
                              touched={touched}
                              options={albumOptions}
                              values={values}
                              setFieldValue={setFieldValue}
                              data-cy='add-csr-album-select-field'
                            />
                          </div>

                          {chosenFileType?.systemName === 'image' ? (
                            <div className='col-md-6 col-xs-12'>
                              <FormInputMediaManager
                                labelClassName='col-md-12'
                                containerClassName='col-md-12'
                                label='Image'
                                name='file'
                                setFieldValue={setFieldValue}
                                setImageUrl={setFileUrl}
                                value={values?.file}
                                data-cy='add-csr-input-media-field'
                              />
                              {!isEmpty(values?.file) ? (
                                <>
                                  <li className='listing'>
                                    <div className='thumbImageBlock'>
                                      <button
                                        type='button'
                                        title='Remove'
                                        className='btn thumbImage-remove d-flex align-items-center justify-content-center btn-primary'
                                        onClick={() => {
                                          setFieldValue('file', '')
                                        }}
                                        data-cy='file-remove-button'
                                      >
                                        Delete
                                      </button>

                                      <img
                                        className='thumbImage w-100 h-100'
                                        src={`${imageBaseUrl}/${values.file}`}
                                        alt=''
                                        data-cy='add-csr-image'
                                      />
                                    </div>
                                  </li>
                                </>
                              ) : null}
                            </div>
                          ) : chosenFileType?.systemName === 'video' ? (
                            <div className='col-md-6 col-xs-12'>
                              <FormTextBox
                                type='text'
                                labelClassName='col-md-12'
                                containerClassName='col-md-12'
                                placeholder='Iframe '
                                label='Iframe'
                                name='file'
                                onChange={handleChange}
                                errors={errors}
                                touched={touched}
                                as='textarea'
                                data-cy='add-csr-Iframe-text-field'
                              />
                            </div>
                          ) : null}

                          <div className='col-md-6 col-xs-12'>
                            <FormInputMediaManager
                              labelClassName='col-md-12'
                              containerClassName='col-md-12'
                              label='Thumbnail Image'
                              name='thumbnailImage'
                              setFieldValue={setFieldValue}
                              setImageUrl={setThumbImageUrl}
                              value={values?.thumbnailImage}
                              data-cy='add-csr-thumbnail-input-field'
                            />

                            {!isEmpty(values?.thumbnailImage) && (
                              <>
                                <li className='listing'>
                                  <div className='thumbImageBlock'>
                                    <button
                                      type='button'
                                      title='Remove'
                                      className='btn thumbImage-remove d-flex align-items-center justify-content-center btn-primary'
                                      onClick={() => {
                                        setFieldValue('thumbnailImage', '')
                                      }}
                                      data-cy='thumbnail-remove-button'
                                    >
                                      Delete
                                    </button>

                                    <img
                                      className='thumbImage w-100 h-100'
                                      src={`${imageBaseUrl}/${values.thumbnailImage}`}
                                      alt=''
                                      data-cy='add-csr-thumbnail'
                                    />
                                  </div>
                                </li>
                              </>
                            )}
                          </div>
                        </div>

                        <div className='col-md-6 col-xs-12 mt-5'>
                          <FormSelect
                            type='text'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='File Type'
                            label='Image or Video'
                            name='fileType'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            options={fileOptions}
                            values={values}
                            setFieldValue={setFieldValue}
                            data-cy='add-csr-file-type-select'
                          />
                        </div>

                        <div className='col-md-6 col-xs-12 mt-5'>
                          <FormTextBox
                            type='date'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Publish Date'
                            label='Publish Date'
                            name='published_date'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            data-cy='add-csr-publish-date-text-field'
                          />
                        </div>

                        <div className='col-md-6 col-xs-12'>
                          <label className='form-label fw-bolder text-dark fs-6 required'>
                            Status
                          </label>

                          <div className='d-flex ms-5'>
                            {statusOptions?.map((status: {label: string; value: string}) => (
                              <FormRadio
                                containerClassName=''
                                label='Select Status'
                                name='status'
                                type='radio'
                                onChange={handleChange}
                                errors={errors}
                                touched={touched}
                                required={true}
                                checkBoxText={status?.label}
                                value={status?.value}
                                data-cy='add-csr-status-radio-field'
                              />
                            ))}
                          </div>
                          <div className='fv-plugins-message-container text-danger fw-bolder small text-end mt-1'>
                            <ErrorMessage
                              name='status'
                              component='div'
                              className='field-error-message'
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='d-flex justify-content-end px-9 '>
                      <button
                        type='submit'
                        disabled={loading}
                        className='btn btn-primary btn-sm ms-3'
                        data-cy='modal-submit'
                      >
                        Save
                      </button>
                      <button
                        type='button'
                        onClick={handleClose}
                        className='btn btn-secondary btn-sm ms-3'
                        data-cy='modal-cancel'
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )
              }}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default AddCsr
